/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Manual_Fill_TriggerInputs */

const en_case_manual_fill_trigger = /** @type {(inputs: Case_Manual_Fill_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in manually`)
};

const pt_br2_case_manual_fill_trigger = /** @type {(inputs: Case_Manual_Fill_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preencher manualmente`)
};

/**
* | output |
* | --- |
* | "Fill in manually" |
*
* @param {Case_Manual_Fill_TriggerInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_manual_fill_trigger = /** @type {((inputs?: Case_Manual_Fill_TriggerInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Manual_Fill_TriggerInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_manual_fill_trigger(inputs)
	return pt_br2_case_manual_fill_trigger(inputs)
});